import * as React from "react";
import { useState, useEffect } from 'react';
import {
  Link,
  Button,
  List,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  CardActions,
  DateField, GET_LIST, GET_ONE
} from "react-admin";
import {
  prop,
  isNil,
} from "ramda";
import People from "@material-ui/icons/People";
import dataProviderFactory from "../dataProvider";
import { getPermissionRole } from "../util";

const DuplicatesFind = object => {
  const [duplicates, setDuplicates] = useState({ data: [], total: 0 });
  const permissions = JSON.parse(localStorage.getItem("permissions"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataProvider = await dataProviderFactory("rest");
        const duplicatesResponse = await dataProvider(GET_LIST, "clientsMerge/getDuplicates/Accounts", {
          filter: {
            client_last_name: object.record.client_last_name,
            client_birth_date: object.record.client_birth_date,
            nationality: object.record.country_id,
            anchor_client_id: object.record.id,
          },
          pagination: {
            page: 1,
            perPage: 99,
          },
          sort: { field: object.record.id, order: "DESC" },
        });

        setDuplicates(duplicatesResponse);
      } catch (error) {
        console.error('error: ', error);
        setDuplicates({ data: [], total: 0 });
      }
    };

    if (object && object.record && object.record.client_last_name && object.record.client_birth_date && object.record.country_id) {
      fetchData();
    }
  }, [object]);

  if ([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) {
    if (duplicates.total > 1) {
      return (
        <React.Fragment>
          <Button
            component={Link}
            //target="_blank"
            to={{
              pathname: `/mergeAccounts/${object.record.id}`,
            }}
            label="Merge"
            style={{ padding: "10px" }}
            onClick={() => setDuplicatesClients(duplicates.data)}
          >
            <People/>
          </Button>
        </React.Fragment>
      );
    } else {
      return null;
    } 
  } else {
    return null;
  } 

}

const setDuplicatesClients = (data) => {
  localStorage.setItem('toMerge', JSON.stringify(data))
}

export const MergeList = props => (
  <List
    {...props}
    title="Duplicate Accounts"
    resource="clientsMerge"
    bulkActionButtons={false}
    pagination={false}
  >
    <Datagrid>
      <TextField label="Customer ID" source="id" />
      <TextField label="First Name" source="client_first_name" />
      <TextField label="Last Name" source="client_last_name" />      
      <DateField label="Birthdate" source="client_birth_date" />            
      <ReferenceField
        label="Country"
        source="country_id"
        reference="countries"
        linkType={false}
      >      
        <TextField source="country" />
      </ReferenceField>       
      <TextField label="City" source="client_city" />
      {/* <ReferenceField
        label="Email"
        source="user_id"
        reference="users"
        linkType={false}
        allowEmpty={true}
      >
        <TextField source="email" />
      </ReferenceField> */}
        <TextField label="Email" source="email" />  
      <DuplicatesFind />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/resources/clientsMerge.js